import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import logUserAction from "../../apis/userLogger";
import useGetTrialTypes from "../../hooks/useGetTrialTypes";
import { CustomDatePicker } from "../UI/CustomDatePicker";

const AddNewTrial = (props) => {
  const { data: trialTypes = [] } = useGetTrialTypes();

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    props.setTrialInfo((trial) => ({
      ...trial,
      [name]: value,
    }));
  };

  return (
    <Dialog open onClose={() => props.handleModalHide()} maxWidth="sm" fullWidth>
      <DialogTitle>
        {props.isEdit ? "Edit Trial" : props.isDuplicate ? "Duplicate Trial" : "Add Trial"}
        <IconButton
          aria-label="close"
          onClick={() => props.handleModalHide()}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField
            fullWidth
            required
            label="Custom Id"
            size="small"
            placeholder="ID"
            name="trial_custom_id"
            value={props.trialInfo.trial_custom_id}
            onChange={handleFieldChange}
          />
          <TextField
            fullWidth
            required
            label="Name"
            size="small"
            placeholder="Name"
            name="name"
            value={props.trialInfo.name}
            onChange={handleFieldChange}
          />
          <FormControl fullWidth size="small" required>
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              name="status"
              value={props.trialInfo.status}
              onChange={handleFieldChange}
              SelectDisplayProps={{ "data-testid": "add-trial-status-trigger" }}
            >
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
              <MenuItem value="Archived">Archived</MenuItem>
            </Select>
          </FormControl>
          {(!props.isEdit || props.isDuplicate) && (
            <FormControl fullWidth size="small" required>
              <InputLabel>Trial Structure</InputLabel>
              <Select
                label="Trial Structure"
                name="trial_structure"
                value={props.trialInfo.trial_structure}
                onChange={handleFieldChange}
                SelectDisplayProps={{ "data-testid": "add-trial-structure-trigger" }}
              >
                <MenuItem value="visit_based">Visit Based</MenuItem>
                <MenuItem value="session_based">Session Based</MenuItem>
              </Select>
            </FormControl>
          )}
          <FormControl fullWidth size="small" required>
            <InputLabel>Trial Type</InputLabel>
            <Select
              label="Trial Type"
              name="trial_type"
              value={props.trialInfo.trial_type || ""}
              onChange={handleFieldChange}
              SelectDisplayProps={{ "data-testid": "add-trial-type-trigger" }}
            >
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              {trialTypes.map((type) => (
                <MenuItem value={type.id} key={type.id}>
                  {type.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small" required>
            <InputLabel>Environment</InputLabel>
            <Select
              label="Environment"
              name="environment"
              value={props.trialInfo.environment || ""}
              onChange={handleFieldChange}
              SelectDisplayProps={{ "data-testid": "add-trial-environment-trigger" }}
            >
              <MenuItem value="Live">Live</MenuItem>
              <MenuItem value="UAT">UAT</MenuItem>
            </Select>
          </FormControl>
          <CustomDatePicker
            label="Expected First Enrollment"
            mode="date"
            variant="outlined"
            value={props.trialInfo.expected_first_enrollment || ""}
            onChange={(val) =>
              props.setTrialInfo((prev) => ({ ...prev, expected_first_enrollment: val }))
            }
          />
          <CustomDatePicker
            label="Expected Last Enrollment"
            mode="date"
            variant="outlined"
            value={props.trialInfo.expected_last_enrollment || ""}
            onChange={(val) =>
              props.setTrialInfo((prev) => ({ ...prev, expected_last_enrollment: val }))
            }
          />
          <CustomDatePicker
            label="Expected Study Start Date"
            mode="date"
            variant="outlined"
            value={props.trialInfo.expected_study_start_date || ""}
            onChange={(val) =>
              props.setTrialInfo((prev) => ({ ...prev, expected_study_start_date: val }))
            }
          />
          <CustomDatePicker
            label="Expected Study Completion Date"
            mode="date"
            variant="outlined"
            value={props.trialInfo.expected_study_completion_date || ""}
            onChange={(val) =>
              props.setTrialInfo((prev) => ({ ...prev, expected_study_completion_date: val }))
            }
          />
          <Button
            variant="contained"
            size="small"
            data-testid="add-trial-submit-btn"
            onClick={() => {
              const actionType = props.isEdit ? "Update" : props.isDuplicate ? "Duplicate" : "Add";
              logUserAction(`Click on ${actionType} button`, "", `${props.trialInfo.name}`);
              props.handleAddTrial();
            }}
            sx={{ alignSelf: "flex-end" }}
          >
            {props.isEdit ? "Update" : props.isDuplicate ? "Duplicate" : "Add"}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AddNewTrial;
